import * as React from "react";
import Ajax from "../../Ajax";
import swal from 'sweetalert';
import ReactTooltip from 'react-tooltip';

interface IFormProps {
  type: object
}
interface MyStates {
  ajaxLoaded: boolean,
  spinner: string,
  type: object,
  excludes: object,
}
export default class ExclusionEdit extends React.Component<IFormProps, MyStates>{

  constructor(props:IFormProps) {
    super(props);

    this.state = {
      ajaxLoaded: true,
      spinner: 'none',
      type: this.props.type,
      excludes: {},
    }

    this.loadExcludes()
  }

  private loadExcludes(){
    var ajax = new Ajax(window.location.origin + '/reservatio/beallitasok/getExclusion/' + this.props.type['id']);
    ajax.doPost({}).then((response) => {
      this.setState({
        excludes: response,
        ajaxLoaded: true,
      })
    })
  }

  private removeExclusion( id ){
    swal({
        title: "Biztos, hogy végrehajtod ezt a műveletet?",
        icon: "warning",
        buttons: {
            confirm: {
              text: "Igen",
              value: true,
              visible: true,
              className: "float-right btn-success",
              closeModal: true
            },
            cancel: {
              text: "Mégse",
              value: false,
              visible: true,
              className: "float-left btn-danger",
              closeModal: true,
            }
        }
    })
    .then((willDelete) => {
        if (willDelete) {
          var ajax = new Ajax(window.location.origin + '/reservatio/beallitasok/removeExclusion/' + id);
          ajax.doPost({}).then((response) => {
            this.setState({
              excludes: response,
              ajaxLoaded: true,
            })
          })
        }
    });
  }

  private createExclusionHandleSubmit(e){
    e.preventDefault();

    var ajax = new Ajax(window.location.origin + '/reservatio/beallitasok/addExclusion/' + this.props.type['id']);
    ajax.doPost('add_exclusion_' + this.props.type['id'], true).then((response) => {
      this.setState({
        excludes: response.data,
        ajaxLoaded: true,
      }, () => swal({ title: response.message, icon: response.status }))
    })
  }


  public render() {
    let type = this.props.type

    return (
      <>
        {Object.keys(this.state.excludes).map( (i) => {
          let e = this.state.excludes[i]

          return (
            <div className="form-group" key={"excludes_" + this.props.type['id'] + '_' + i}>
              <div className="input-group">
                <span className="input-group-addon">
                  <b>{e.day}</b>&nbsp;&nbsp;
                    <ReactTooltip />
                    <i className="fa fa-question-circle" style={{cursor: 'help'}} data-tip={e.comment}></i>
                </span>
                <span className="input-group-addon" style={{textAlign: 'right'}}>
                  <button type="button" className="btn btn-danger btn-sm" onClick={() => this.removeExclusion(e.id)}><i className="fa fa-trash"></i></button>
                </span>	
              </div>
            </div>
          )
        })
      }
      <hr />
      <form id={'add_exclusion_' + this.props.type['id']} onSubmit={(e) => this.createExclusionHandleSubmit(e)}>
        <div className="row">
          <div className="col-md-12 form-group">
            <input type="date" name="day" className="form-control" placeholder="Dátum" required />
          </div>
        </div>
        <div className="row">
          <div className="col-md-12 form-group">
            <textarea name="comment" className="form-control" placeholder="Megjegyzés"></textarea>
          </div>
        </div>
        <div className="row">
          <div className="col-md-12">
            <button type="submit" className="btn btn-success btn-sm pull-right">Hozzáadás</button>
          </div>
        </div>
      </form>
    </>
    )
  }
}